import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CompanySearchPage = withSuspense(lazy(() => import('./company-search')));
export default CompanySearchPage;
